export const GET_CLIENTS_DATA : string = "GET_CLIENTS_DATA";
export const LOADING: string = "LOADING";

